export default "/assets/website/images/2021.jpeg?e8298a6357056daa0d714092a3629a12";